import React, {
  PropTypes as T,
  Component,
} from 'react';
import radium, { StyleRoot } from 'radium';
import { Link as link } from 'react-router';
import logoImage from '../static/images/logo.png';
import Footer from './Footer.js';
import Sidebar from './Sidebar.js';
import Helpers from '../helpers'

const Link = radium(link);

const styles = {
  wrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    height: '100%',
    padding: '0 0 60px 0',
    minHeight: 530,
  },
  header: {
    height: 90,
    width: '100%',
    boxShadow: '0 3px 0 0 #fed312',
    padding: '0 24px',
    lineHeight: '90px',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    position: 'relative',
    minHeight: 90,
  },
  logo: {
    width: 150,
    display: 'block',
  },
  logoWrap: {
    width: 208,
    display: 'flex',
    justifyContent: 'center',
  },
  title: {
    fontSize: 16,
    color: '#004d9f',
    letterSpacing: 4,
    opacity: 0.4,
    fontWeight: 300,
    margin: '0 0 0 44px',
    '@media (max-width: 767px)': {
      display: 'none',
    },
  },
  mainField: {
    flex: 1,
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    backgroundColor: '#FBFBF6',
    '@media (max-width: 1024px)': {
      display: 'block',
    },
  },
  mainField_TV: {
    flex: 1,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    backgroundColor: '#FBFBF6',
  },
  main: {
    flex: 1,
    maxHeight: 'calc(100vh - 150px)',
    overflow: 'auto',
    '@media (max-width: 767px)': {
      maxHeight: 'none',
      marginBottom: 60,
    },
  },
};

class MainBoard extends Component {
  findTitle(routes) {
    const hasTitleRoute = routes.reverse().find((route) => !!route.title);

    if (hasTitleRoute) {
      return hasTitleRoute.title;
    }

    return '';
  }

  findGroup(routes) {
    const hasTitleRoute = routes.reverse().find((route) => !!route.group);

    if (hasTitleRoute) {
      return hasTitleRoute.group;
    }

    return null;
  }

  render() {
    const {
      routes,
      children,
    } = this.props;

    var sidebar = <Sidebar group={this.findGroup(routes)} />;
    var mainField = styles.mainField;

    if (Helpers.Session.isViaTV()) {
      sidebar = null;
      mainField = styles.mainField_TV;
    }

    return (
      <StyleRoot style={styles.wrapper}>
        <header style={styles.header}>
          <Link to="/" style={styles.logoWrap}>
            <img alt="logo" src={logoImage} style={styles.logo} />
          </Link>
          <h1 style={styles.title}>{this.findTitle(routes)}</h1>
        </header>
        <div style={mainField}>
          {sidebar}
          <main style={styles.main}>
            {children}
          </main>
        </div>
        <Footer />
      </StyleRoot>
    );
  }
}

MainBoard.propTypes = {
  children: T.node,
  routes: T.array,
};

export default MainBoard;



// WEBPACK FOOTER //
// ./components/MainBoard.js